import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

export const userForgetPassword = createAsyncThunk(
  "forgotpwd/userForgetPassword",
  async (user: any, { rejectWithValue }) => {
    try {
      // Replaced old fake/firebase logic with a standard REST API call wrapper
      const response: any = await api.create("/auth/forgot-password", { email: user.email });
      
      return response?.message || "Reset link will be sent to your mailbox if the email exists.";
    } catch (forgetError: any) {
      return rejectWithValue(forgetError?.message || String(forgetError));
    }
  }
);
